import NovelTurnScriptList from '../pages/novelTurnScript/list.vue'//ai对话的初始化页面
import NovelTurnScriptAdd from '../pages/novelTurnScript/add.vue'//ai对话的初始化页面
import NovelTurnScriptChapter from '../pages/novelTurnScript/chapterList.vue'//ai对话的初始化页面
import NovelTurnScriptAiCreate from '../pages/novelTurnScript/aiCreate.vue'//ai对话的初始化页面
const routes = [
  {
    path: '/novelTurnScript_list',
    name: 'novelTurnScript_list',
    component: NovelTurnScriptList,
  },
  {
    path: '/novelTurnScript_add',
    name: 'novelTurnScript_add',
    component: NovelTurnScriptAdd,
  },
  {
    path: '/novelTurnScript_chapter',
    name: 'novelTurnScript',
    component: NovelTurnScriptChapter,
  },
  {
    path: '/novelTurnScript_aiCreate',
    name: 'novelTurnScript_aiCreate',
    component: NovelTurnScriptAiCreate,
  },
];
export default routes